<status-chip [title]="status | titlecase" [status]="chipStatus" [tooltipText]="statusTooltip | translate">
</status-chip>
